import { render, staticRenderFns } from "./RankingHeader.vue?vue&type=template&id=b64100cc&scoped=true"
import script from "./RankingHeader.vue?vue&type=script&lang=js"
export * from "./RankingHeader.vue?vue&type=script&lang=js"
import style0 from "./RankingHeader.vue?vue&type=style&index=0&id=b64100cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b64100cc",
  null
  
)

export default component.exports